import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// export default props => {
//   return <iframe style={styles.container} src={props.url} frameBorder="0" />;
// };

export default class MatterportFrame extends Component {
  state = {
    mpIframe: null
  };

  componentDidMount() {
    // this.refs.iframe.getDOMNode().addEventListener('load', this.props.onLoad);
    let iframeNode = ReactDOM.findDOMNode(this.refs.iframe);
    iframeNode.addEventListener('load', this.props.onLoad);

    this.setState({ mpIframe: iframeNode });
  }

  render() {
    const autoplay =
      this.props.firstLoad && !this.props.autoload ? '' : '&play=1';
    return (
      <iframe
        ref="iframe"
        id="mpIframe"
        allow="vr"
        style={styles.container}
        src={`${this.props.url}${autoplay}`}
        frameBorder="0"
      />
    );
  }
}

const styles = {
  container: {
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    height: '100%'
  }
};



// WEBPACK FOOTER //
// ./src/components/MatterportFrame.js